<ng-container *ngIf="isLoggedIn && !connecting">
  <app-request-permission
    *ngIf="!hasMediaPermission && !isRecordingBot"
    (hasMediaPermission)="onMediaPermissionChange($event)">
  </app-request-permission>

  <div *ngIf="hasMediaPermission || isRecordingBot" class="main">
    <stusan-header></stusan-header>
    <stusan-videos [videos]="janusService.videos$ | async"
                   (click)="toggleMobileMenu($event)"
    ></stusan-videos>
    <!-- TODO: Replace hiding via display:none to ngIf via transferring logic from recording-control to recording.service  -->
    <stusan-controls [style.display]="isRecordingBot ? 'none' : 'flex'"></stusan-controls>
  </div>
  <div class="side">
  </div>
<!--  <div class="hand-raising">-->
<!--    <div class="hand-raising__item"-->
<!--         *ngFor="let item of (handsState$ | async); index as i; trackBy:trackByMethod"-->
<!--    >-->
<!--      <div class="hand-raising__item-inner">-->
<!--        <stusan-icon icon="hand"-->
<!--                     class="hand-raising__icon hand-raising__icon&#45;&#45;hand"-->
<!--                     [style.fill]="'#0299DB'"-->
<!--                     style="width: 35px; height: 43px;"-->
<!--        ></stusan-icon>-->
<!--        <span class="hand-raising__avatar">-->
<!--          <span class="hand-raising__pic"-->
<!--                [attr.alt]="item.displayName"-->
<!--          ></span>-->
<!--          <span class="hand-raising__char">{{ firstChar(item.displayName) }}</span>-->
<!--        </span>-->
<!--        <span class="hand-raising__text">{{ item.displayName }}</span>-->
<!--        <div class="hand-raising__close">-->
<!--          <stusan-icon icon="close"-->
<!--                       (click)="hideRaisedHand(item.id)"-->
<!--                       class="hand-raising__icon hand-raising__icon&#45;&#45;close"-->
<!--                       style="width: 26px; height: 34px; fill: rgba(0,0,0,.14);"-->
<!--          ></stusan-icon>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</ng-container>
<div class="loader" *ngIf="connecting">
  <div class="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
